import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
    Input,
} from '@chakra-ui/react';
import { Card } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const CustomAttributeField = ({
    darkMode,
    attributeIndex,
    value,
    onChange,
    error,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const fieldName = `attribute${attributeIndex}`;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!error}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Custom Attribute {attributeIndex}
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a custom attribute value for this address.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Input
                            id={fieldName}
                            name={fieldName}
                            value={value || ''}
                            onChange={(e) =>
                                onChange(fieldName, e.target.value)
                            }
                            placeholder={`Custom Attribute ${attributeIndex}`}
                            maxLength={100}
                            borderColor={
                                darkMode ? 'dark.tcap-borderGray' : 'gray.200'
                            }
                            backgroundColor={darkMode ? 'dark.tcap' : 'white'}
                            color={darkMode ? 'dark.textDark' : null}
                        />
                        {error && (
                            <Text color="red.500" fontSize="sm">
                                {error}
                            </Text>
                        )}
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a custom attribute value for this address (max 100 characters)."
                        ariaLabel={`custom-attribute-${attributeIndex}-tip`}
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

const AddressCustomAttributes = ({
    darkMode,
    addressFields,
    setAddressField,
    errors = {},
}) => {
    return (
        <Card
            borderRadius={15}
            padding="0px 30px"
            maxWidth={895}
            ml={0}
            mt={4}
            bg={darkMode ? 'dark.tcap' : null}>
            <Text
                fontSize="lg"
                sx={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    marginTop: '20px',
                }}>
                Custom Attributes
            </Text>
            <Box pb={4}>
                {[1, 2, 3].map((index) => (
                    <CustomAttributeField
                        key={index}
                        darkMode={darkMode}
                        attributeIndex={index}
                        value={addressFields[`attribute${index}`]}
                        onChange={setAddressField}
                        error={errors[`attribute${index}`]}
                    />
                ))}
            </Box>
        </Card>
    );
};

export default AddressCustomAttributes;
